import { Props } from "../../../../src/props";
import { Spinner } from '@primer/react';
import * as React from 'react';
export default {
  Props,
  Spinner,
  React
};